import { AppScreens } from '@/shared/types';

export const AUTOPLAY_TIMEOUT = 15000;

export const saveLastActiveAppScreens: AppScreens[] = [
  AppScreens.VideoBible,
  AppScreens.PrayerExperience,
  AppScreens.Story,
  AppScreens.InteractiveBible,
  AppScreens.ReadingPlans,
  AppScreens.ReadingPlanDetail,
  AppScreens.ReadingPlanDay,
  AppScreens.TextBible,
];
